import { render } from "./allocating.vue?vue&type=template&id=220f0cc8&scoped=true"
import script from "./allocating.vue?vue&type=script&lang=js"
export * from "./allocating.vue?vue&type=script&lang=js"

import "./allocating.vue?vue&type=style&index=0&id=220f0cc8&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220f0cc8"]])

export default __exports__